export default __webpack_public_path__ + "static/media/EAST1020.34I-33760_-18278_0.bbe10bb1.jpg";